import {
  AssessmentPDFRequest,
  AssessmentPdfControllerApi,
} from "../../../services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "../../../utils/utils";

/**
 * @author [Rajkumar Rathod]
 */
export const usePatientAssessmentPdfDownload = () =>
  useMutationWithLoading(
    async (params: {
      assessmentPDFRequest: AssessmentPDFRequest;
      xTENANTID?: string;
    }) =>
      new AssessmentPdfControllerApi(getConfigObject()).generateAssessmentPDF(
        params.assessmentPDFRequest,
        params.xTENANTID || getXtenantId(),
        { responseType: "blob" }
      )
  );
